const accordionsController = () => {
  const accordions = document.querySelectorAll('.accordion-item')

  const openAccordion = (accordion) => accordion.classList.add('active')
  const closeAccordion = (accordion) => accordion.classList.remove('active')
  
  const closeAllAccordions = () => {
    accordions.forEach((accordion) => closeAccordion(accordion))
  }

  accordions.forEach((accordion) => {
    accordion.addEventListener('click', () => {
      closeAllAccordions()
      openAccordion(accordion)
    })
  })
}

accordionsController()


// WEBPACK FOOTER //
// ./scripts/components/accordions.js